import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-108182d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_3 = ["for"]
const _hoisted_4 = ["value", "id"]
const _hoisted_5 = {
  key: 0,
  class: "m-0 p-0"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "" },
    options: { default: () => [] }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "form-check",
        key: 'option_' + index
      }, [
        _createElementVNode("label", {
          class: "form-check-label text-primary d-flex justify-content-between py-3",
          for: 'option_' + index
        }, [
          _createTextVNode(_toDisplayString(item.name || item.title) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: item.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
            id: 'option_' + index,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onChange($event)))
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, _ctx.model.$model]
          ])
        ], 8, _hoisted_3),
        (index + 1 !== _ctx.options.length)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})